import AlertActionTypes from './alert-types'

const INITIAL_STATE = {
    errorAlertText: null,
    errorAlert: false,
    successAlertText: null,
    successAlert: false,
    infoAlertText: null,
    infoAlert: false,
    warningAlertText: null,
    warningAlert: false,
    notificationAlert: false,
    notifications: null,
    appNotifications: null,
}

const alertReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case AlertActionTypes.START_ERROR_ALERT_DISPLAY:
            return {
                ...state,
                errorAlertText: action.payload,
                errorAlert: true,
            }
        case AlertActionTypes.FINISH_ERROR_ALERT_DISPLAY:
            return {
                ...state,
                errorAlertText: null,
                errorAlert: false,
            }

        case AlertActionTypes.START_SUCCESS_ALERT_DISPLAY:
            return {
                ...state,
                successAlertText: action.payload,
                successAlert: true,
            }
        case AlertActionTypes.FINISH_SUCCESS_ALERT_DISPLAY:
            return {
                ...state,
                successAlertText: null,
                successAlert: false,
            }
        case AlertActionTypes.START_INFO_ALERT_DISPLAY:
            return {
                ...state,
                infoAlertText: action.payload,
                infoAlert: true,
            }
        case AlertActionTypes.FINISH_INFO_ALERT_DISPLAY:
            return {
                ...state,
                infoAlertText: null,
                infoAlert: false,
            }
        case AlertActionTypes.START_WARNING_ALERT_DISPLAY:
            return {
                ...state,
                warningAlertText: action.payload,
                warningAlert: true,
            }
        case AlertActionTypes.FINISH_WARNING_ALERT_DISPLAY:
            return {
                ...state,
                warningAlertText: null,
                warningAlert: false,
            }
        case AlertActionTypes.START_NOTIFICATION_ALERT_DISPLAY:
            return {
                ...state,
                notifications: action.payload,
                notificationAlert: true,
            }
        case AlertActionTypes.FINISH_NOTIFICATION_ALERT_DISPLAY:
            return {
                ...state,
                notifications: null,
                notificationAlert: false,
            }

        case AlertActionTypes.SUCCESS_FETCH_APP_NOTIFICATIONS:
            return {
                ...state,
                appNotifications: action.payload,
            }

        case AlertActionTypes.FINISH_FETCH_APP_NOTIFICATIONS:
        case AlertActionTypes.FAILURE_FETCH_APP_NOTIFICATIONS:
            return {
                ...state,
                appNotifications: null,
            }

        case AlertActionTypes.START_DELETE_APP_NOTIFICATION:
            return {
                ...state,
                appNotifications: state.appNotifications.filter(notification => notification.id !== action.payload),
            }
        // case AlertActionTypes.FAILURE_DELETE_APP_NOTIFICATION:
        //     return {
        //         ...state,
        //     }

        default:
            return state
    }
}

export default alertReducer
